import { getUserAgent } from '/@/utils/index';

export const useFireFoxStyle = () => {
  const userAgent = getUserAgent();
  if (userAgent.includes('firefox')) {
    document.body.classList.add('is-firefox');
  }
};
